$mol_icon_square_outline $mol_icon path \M3,3H21V21H3V3M5,5V19H19V5H5Z
